import { InboundShipment } from "@deliverr/inbound-client";
import { createActionCreator } from "common/ReduxUtils";
import { InboundShipmentActionTypes } from "inbounds/store/actions/shipment/InboundShipmentActionTypes";

export const updateShipment = createActionCreator<number, InboundShipment>(
  InboundShipmentActionTypes.UPDATE_SHIPMENT,
  "shipmentId",
  "updatedShipment"
);
